import React from 'react';

// A small, deliberately illustrated arcade sandwich, not a product photograph.
export default function SandwichDrawing() {
  return <svg className="sandwich-drawing" viewBox="0 0 240 150" fill="none" aria-hidden="true">
    <path d="M24 110 118 75l98 28-91 39z" fill="#d49342" stroke="#542c20" strokeWidth="3" />
    <path d="m24 101 94-35 98 28-91 39z" fill="#f5df9e" stroke="#542c20" strokeWidth="3" />
    <path d="m30 93 85-30 94 23-28 13-19-3-14 17-18-5-22 14-21-8-20 3z" fill="#699043" stroke="#38552d" strokeWidth="3" />
    <path d="M30 78c18-12 24 5 41-8s24 0 40-9 24 6 42 4 27 7 46 9l11 14c-19 1-25-9-42 4s-29-1-43 13-26-5-41 5-27-8-44-4z" fill="#ba5653" stroke="#703c36" strokeWidth="3" />
    <path d="m35 69 90-31 84 29-43 13-20-4-18 17z" fill="#f3d580" stroke="#845a30" strokeWidth="3" />
    <path d="M26 61c-2-21 68-53 103-50 33 4 85 20 87 41l-2 14-90 31-94-24z" fill="#d89e53" stroke="#542c20" strokeWidth="3" />
    <path d="M27 61c4-18 73-49 102-46 33 3 82 19 85 37l-90 33z" fill="#f6dfac" stroke="#542c20" strokeWidth="3" />
    <path d="m74 43 6 3m20-15 6 2m20 23 5 2m22-25 5 3m25 11 5 2m-73 17 5 2" stroke="#ad803f" strokeWidth="3" strokeLinecap="round" />
  </svg>;
}
